"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maximumObjectPanelWidth = exports.initialRightPanelWidth = exports.minRightPanelWidth = exports.initialEditorLeftPanelWidth = exports.initialLeftPanelWidth = exports.minLeftPanelWidth = exports.LeftEditorDrawerTabStateOld = exports.LeftEditorDrawerTabState = exports.RightEditorDrawerTabState = void 0;
var RightEditorDrawerTabState;
(function (RightEditorDrawerTabState) {
    RightEditorDrawerTabState["inspector"] = "inspector";
    RightEditorDrawerTabState["inspectorNew"] = "inspector-new";
    RightEditorDrawerTabState["copilotChat"] = "copilotChat";
    RightEditorDrawerTabState["review"] = "review";
    // Internal tabs
    RightEditorDrawerTabState["CLI"] = "CLI";
    RightEditorDrawerTabState["prompt"] = "prompt";
    RightEditorDrawerTabState["CAL"] = "CAL";
})(RightEditorDrawerTabState || (exports.RightEditorDrawerTabState = RightEditorDrawerTabState = {}));
var LeftEditorDrawerTabState;
(function (LeftEditorDrawerTabState) {
    LeftEditorDrawerTabState["componentLibrary"] = "componentLibrary";
    LeftEditorDrawerTabState["objects"] = "objects";
    LeftEditorDrawerTabState["rules"] = "rules";
})(LeftEditorDrawerTabState || (exports.LeftEditorDrawerTabState = LeftEditorDrawerTabState = {}));
// TODO: Remove this once the new layout is fully rolled out.
var LeftEditorDrawerTabStateOld;
(function (LeftEditorDrawerTabStateOld) {
    LeftEditorDrawerTabStateOld[LeftEditorDrawerTabStateOld["componentLibrary"] = 0] = "componentLibrary";
    LeftEditorDrawerTabStateOld[LeftEditorDrawerTabStateOld["objects"] = 1] = "objects";
    LeftEditorDrawerTabStateOld[LeftEditorDrawerTabStateOld["rules"] = 2] = "rules";
})(LeftEditorDrawerTabStateOld || (exports.LeftEditorDrawerTabStateOld = LeftEditorDrawerTabStateOld = {}));
/**
 * Panel widths
 *
 * Note: both left and right panels are resizable.
 */
exports.minLeftPanelWidth = 350;
exports.initialLeftPanelWidth = 276;
exports.initialEditorLeftPanelWidth = 440;
exports.minRightPanelWidth = 276;
exports.initialRightPanelWidth = 350;
exports.maximumObjectPanelWidth = 480;
//# sourceMappingURL=uiState.js.map